import {
  FCCustomizationCombined,
  FeatureCatalog as FeatureCatalogGenerated,
  AnyFeatureCatalogInfo as AnyFeatureCatalogInfoGenerated,
  Language as LanguageGenerated,
  AttributeType as AttributeTypeGenerated,
  AttributeTypeCreateRequest as AttributeTypeCreateRequestGenerated,
  AttributeTypeGroup as AttributeTypeGroupGenerated,
  CustomFeatureTypeGroupAffiliation as CustomFeatureTypeGroupAffiliationGenerated,
  CustomAttributeType as CustomAttributeTypeGenerated,
  FeatureTypeGroupAffiliation as FeatureTypeGroupAffiliationGenerated,
  FeatureTypeGroup as FeatureTypeGroupGenerated,
  FeatureType as FeatureTypeGenerated,
  FCFeatureType as FCFeatureTypeGenerated,
  FeatureTypeReference as FeatureTypeReferenceGenerated,
  CustomFeatureType as CustomFeatureTypeGenerated,
  AttributeTypeGroupUsage as AttributeTypeGroupUsageGenerated,
  AttributeTypeGroupUsageUpdateRequest as AttributeTypeGroupUsageUpdateRequestGenerated,
  CoClassCreateRequest as CoClassCreateRequestGenerated,
  CustomizationStatus as CustomizationStatusGenerated,
  ClassificationHeader as ClassificationHeaderGenerated,
  AttributeDataTypes as AttributeDataTypesGenerated,
  LegalAttributeValue as LegalAttributeValueGenerated,
  LegalValueCreateRequest as LegalValueCreateRequestGenerated,
  LegalValueUpdateRequest as LegalValueUpdateRequestGenerated,
  ClassificationReference,
  FCCustomization,
  Classification as ClassificationGenerated,
  UserRole as UserRoleGenerated,
  UserRoleUpdateRequest as UserRoleUpdateRequestGenerated,
  UserRoleCreateRequest as UserRoleCreateRequestGenerated,
  Roles as RolesGenerated,
  MeasureTypes as MeasureTypesGenerated,
  ConversionRule as ConversionRuleGenerated,
  ConversionRuleCreateRequest as ConversionRuleCreateRequestGenerated,
  ConversionRuleUpdateRequest as ConversionRuleUpdateRequestGenerated,
  FCCustomizationImportProgress as FCCustomizationImportProgressGenerated,
  ProcessStatus as ProcessStatusGenerated,
  ProgressTicketBase as ProgressTicketBaseGenerated,
  ErrorMessage as ErrorMessageGenerated
} from "./generated/QuadriConfigurationApi";

export type ProjectHeader = FCCustomization;
export type Project = FCCustomizationCombined;
export type Classification = ClassificationGenerated;
export type MappedClassification = ClassificationReference;
export type FileResponse = any;
export type FeatureCatalog = FeatureCatalogGenerated;
export type AnyFeatureCatalogInfo = AnyFeatureCatalogInfoGenerated;
export type Language = LanguageGenerated;
export type AttributeType = AttributeTypeGenerated;
export type AttributeTypeCreateRequest = AttributeTypeCreateRequestGenerated;
export type AttributeTypeGroup = AttributeTypeGroupGenerated;
export type CustomAttributeType = CustomAttributeTypeGenerated;
export type CustomFeatureTypeGroupAffiliation = CustomFeatureTypeGroupAffiliationGenerated;
export type FeatureTypeGroupAffiliation = FeatureTypeGroupAffiliationGenerated;
export type FeatureTypeGroup = FeatureTypeGroupGenerated;
export type FeatureType = FeatureTypeGenerated;
export type FCFeatureType = FCFeatureTypeGenerated;
export type FeatureTypeReference = FeatureTypeReferenceGenerated;
export type CustomFeatureType = CustomFeatureTypeGenerated;
export type AttributeTypeGroupUsage = AttributeTypeGroupUsageGenerated;
export type AttributeTypeGroupUsageUpdateRequest = AttributeTypeGroupUsageUpdateRequestGenerated;
export type CoClassCreateRequest = CoClassCreateRequestGenerated;
export type CustomizationStatus = CustomizationStatusGenerated;
export const CustomizationStatus = CustomizationStatusGenerated;
export type ClassificationHeader = ClassificationHeaderGenerated;
export type AttributeDataTypes = AttributeDataTypesGenerated;
export const AttributeDataTypes = AttributeDataTypesGenerated;
export type LegalAttributeValue = LegalAttributeValueGenerated;
export type LegalValueCreateRequest = LegalValueCreateRequestGenerated;
export type LegalValueUpdateRequest = LegalValueUpdateRequestGenerated;
export type UserRole = UserRoleGenerated;
export type UserRoleUpdateRequest = UserRoleUpdateRequestGenerated;
export type UserRoleCreateRequest = UserRoleCreateRequestGenerated;
export type Roles = RolesGenerated;
export const Roles = RolesGenerated;
export type MeasureTypes = MeasureTypesGenerated;
export const MeasureTypes = MeasureTypesGenerated;
export type ConversionRule = ConversionRuleGenerated;
export type ConversionRuleCreateRequest = ConversionRuleCreateRequestGenerated;
export type ConversionRuleUpdateRequest = ConversionRuleUpdateRequestGenerated;
export type FCCustomizationImportProgress = FCCustomizationImportProgressGenerated;
export type ProcessStatus = ProcessStatusGenerated;
export const ProcessStatus = ProcessStatusGenerated;
export type ProgressTicketBase = ProgressTicketBaseGenerated;
export type ErrorMessage = ErrorMessageGenerated;

export interface UserInfo {
  issuer?: string;
  emailAddress?: string;
  firstName?: string;
  lastName?: string;
  idToken?: string;
  accessToken?: string;
  avatar?: string;
}

export interface ITokenProvider {
  idToken: string;
  accessToken: string;
}

export interface AddToastMessage {
  // ValidationProblemDetails like object
  title?: string;
  detail?: string;
  errors?: { [key: string]: string[] };
  // Error like object
  name?: string;
  message?: string;
}

export enum StreamVersions {
  SV_4110 = "4.110",
  SV_4211 = "4.211"
}